"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CartZipEditState = /** @class */ (function () {
    function CartZipEditState() {
        this.isZipCodeValid = false;
        this.showZipErrorMsg = false;
        this.zipCode = '';
        this.zipEditOpen = false;
        this.nonMandateToMandate = false;
        this.showInsuranceModal = false;
        this.isLoading = false;
    }
    return CartZipEditState;
}());
exports.default = CartZipEditState;
//# sourceMappingURL=CartZipEditState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/CartZipEdit/CartZipEditState.js
// module id = 2252
// module chunks = 8